export const getFirstName = (name?: string) => {
  let fullName: any = name?.split(' ')
  if (fullName?.length > 1) {
    return fullName[0];
  }
  else {
    return name
  }
}